import { SVGProps } from 'react';

const DocumentScaleSmall = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M9.33317 1.51303V4.26673C9.33317 4.64009 9.33317 4.82678 9.40583 4.96938C9.46975 5.09483 9.57174 5.19681 9.69718 5.26073C9.83978 5.33339 10.0265 5.33339 10.3998 5.33339H13.1535M10.6665 8.66668H5.33317M10.6665 11.3333H5.33317M6.6665 6.00001H5.33317M9.33317 1.33334H5.8665C4.7464 1.33334 4.18635 1.33334 3.75852 1.55133C3.3822 1.74308 3.07624 2.04904 2.88449 2.42536C2.6665 2.85319 2.6665 3.41324 2.6665 4.53334V11.4667C2.6665 12.5868 2.6665 13.1468 2.88449 13.5747C3.07624 13.951 3.3822 14.2569 3.75852 14.4487C4.18635 14.6667 4.7464 14.6667 5.8665 14.6667H10.1332C11.2533 14.6667 11.8133 14.6667 12.2412 14.4487C12.6175 14.2569 12.9234 13.951 13.1152 13.5747C13.3332 13.1468 13.3332 12.5868 13.3332 11.4667V5.33334L9.33317 1.33334Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default DocumentScaleSmall;
